import NBXAccounts from 'services/accounts.service';
import { buildTransform } from './transformTaxRecords';

const typeMap = {
  STAKING_ADDRESS_REGISTRATION: 'Staking Address Registration',
  STAKING_TRANSFER: 'Staking Transfer',
  STAKING_REWARD: 'Staking Reward',
  STAKING_REWARD_CLAIM: 'Staking Reward Claim'
};

const transform = buildTransform(typeMap);

export const fetchStakingTaxRecords = year =>
  NBXAccounts.getStakingTaxReports(year).then(records => records.map(transform));
